const iconArr = [{
        path: "/bankList",
        name: "BankList",
        component: () =>
            import ("@/views/icon/bankList.vue"),
        meta: {
            title: "银行代办点"
        }
    },
    {
        path: "/fundList",
        name: "FundList",
        component: () =>
            import ("@/views/icon/fundList.vue"),
        meta: {
            title: "商品房监管银行公示"
        }
    },
    {
        path: "/findProjectName",
        name: "FindProjectName",
        component: () =>
            import ("@/views/icon/findProjectName.vue"),
        meta: {
            title: "项目找房"
        }
    },
    {
        path: "/lotterySignUp",
        name: "lotterySignUp",
        component: () =>
            import ("@/views/icon/lotterySignUp.vue"),
        meta: {
            title: "报名结果"
        }
    },
    {
        path: "/lotteryResult",
        name: "lotteryResult",
        component: () =>
            import ("@/views/icon/lotteryResult.vue"),
        meta: {
            title: "摇号结果"
        }
    },
    {
        path: "/lotteryConfirm",
        name: "lotteryConfirm",
        component: () =>
            import ("@/views/icon/lotteryConfirm.vue"),
        meta: {
            title: "摇号结果"
        }
    },
    {
        path: "/rankList",
        name: "RankList",
        component: () =>
            import ("@/views/icon/rankList.vue"),
        meta: {
            title: "排行榜"
        }
    },
    {
        path: "/recommendList",
        name: "RecommendList",
        component: () =>
            import ("@/views/icon/recommendList.vue"),
        meta: {
            title: "推荐楼盘"
        }
    },
    {
        path: "/buyHouse",
        name: "BuyHouse",
        component: () =>
            import ("@/views/icon/buyHouse.vue"),
        meta: {
            title: "我要买房"
        }
    },
    {
        path: "/distory",
        name: "Distory",
        component: () =>
            import ("@/views/icon/distory.vue"),
        meta: {
            title: "商品房合同注销公示"
        }
    },
    {
        path: "/fundSupervision",
        name: "FundSupervision",
        component: () =>
            import ("@/views/icon/fundSupervision.vue"),
        meta: {
            title: "资金监管"
        }
    },
    {
        path: "/otherSupervision",
        name: "otherSupervision",
        component: () =>
            import ("@/views/icon/otherSupervision.vue"),
        meta: {
            title: "其他监管项目"
        }
    },
    {
        path: "/redBlackRank",
        name: "RedBlackRank",
        component: () =>
            import ("@/views/icon/redBlackRank.vue"),
        meta: {
            title: "明星榜单"
        }
    },
    {
        path: "/server",
        name: "Server",
        component: () =>
            import ("@/views/icon/server.vue"),
        meta: {
            title: "便民服务"
        }
    },
    {
        path: "/keepOnRecord",
        name: "KeepOnRecord",
        component: () =>
            import ("@/views/icon/keepOnRecord.vue"),
        meta: {
            title: "房屋备案状态查询"
        }
    },
    {
        path: "/bankOpreatorList",
        name: "BankOpreatorList",
        component: () =>
            import ("@/views/icon/bankOpreatorList.vue"),
        meta: {
            title: "银行网签操作员签约排行"
        }
    },
    {
        path: "/agentDetail",
        name: "AgentDetail",
        component: () =>
            import ("@/views/icon/agentDetail.vue"),
        meta: {
            title: "经纪人详情"
        }
    },
    {
        path: "/downLoad",
        name: "DownLoad",
        component: () =>
            import ("@/views/icon/downLoad.vue"),
        meta: {
            title: "下载中心"
        }
    },
    {
        path: "/publicAnnouncement",
        name: "PublicAnnouncement",
        component: () =>
            import ("@/views/icon/publicAnnouncement.vue"),
        meta: {
            title: "公告公示"
        }
    },
    {
        path: "/personHasTalk",
        name: "PersonHasTalk",
        component: () =>
            import ("@/views/icon/personHasTalk.vue"),
        meta: {
            title: "业主有话说"
        }
    },
    {
        path: "/search",
        name: "Search",
        component: () =>
            import ("@/views/icon/search.vue"),
        meta: {
            title: "项目搜索"
        }
    }, {
        path: "/newsMain",
        name: "NewsMain",
        component: () =>
            import ("@/views/icon/newsMain.vue"),
        meta: {
            title: "楼盘资讯"
        }
    },
    {
        path: "/preProgress",
        name: "PreProgress",
        component: () =>
            import ("@/views/icon/preProgress.vue"),
        meta: {
            title: "预售进度"
        }
    },
    {
        path: "/lotteryProject",
        name: "lotteryProject",
        component: () =>
            import ("@/views/icon/lotteryProject.vue"),
        meta: {
            title: "项目列表"
        }
    },
    {
        path: "/personLottery",
        name: "personLottery",
        component: () =>
            import ("@/views/icon/personLottery.vue"),
        meta: {
            title: "我的进度",
            isLogin: true
        }
    },
    {
        path: "/aboutBusinessList",
        name: "AboutBusinessList",
        component: () =>
            import ("@/views/icon/aboutBusinessList.vue"),
        meta: {
            title: "涉企房源列表"
        }
    },
    {
        path: "/aboutBusinessDetail",
        name: "AboutBusinessDetail",
        component: () =>
            import ("@/views/icon/aboutBusinessDetail.vue"),
        meta: {
            title: "涉企房源详情"
        }
    },
    {
        path: "/appXieyi",
        name: "appXieyi",
        component: () =>
            import ("@/views/icon/appXieyi.vue"),
        meta: {
            title: "隐私政策"
        }
    }, {
        path: "/zjyhXieyi",
        name: "zjyhXieyi",
        component: () =>
            import ("@/views/icon/zjyhXieyi.vue"),
        meta: {
            title: "用户政策"
        }
    }, {
        path: "/zjysXieyi",
        name: "zjysXieyi",
        component: () =>
            import ("@/views/icon/zjysXieyi.vue"),
        meta: {
            title: "隐私政策"
        }
    }, {
        path: "/jingpinList",
        name: "jinpinList",
        component: () =>
            import ("@/views/icon/jinpinList.vue"),
        meta: {
            title: "精品房源推荐"
        }
    },
    {
        path: "/hxLook",
        name: "hxLook",
        component: () =>
            import ("@/views/icon/hxLook.vue"),
        meta: {
            title: "户型图查看"
        }
    },
    {
        path: "/hxDetail",
        name: "hxDetail",
        component: () =>
            import ("@/views/icon/hxDetail.vue"),
        meta: {
            title: "户型图详情"
        }
    }, {
        path: "/procedure",
        name: "procedure",
        component: () =>
            import ("@/views/icon/procedure.vue"),
        meta: {
            title: "交易流程"
        },
    },
    {
        path: "/appCheck",
        name: "appCheck",
        component: () =>
            import ("@/views/icon/appCheck.vue"),
        meta: {
            title: "徐州市房地产信息网用户协议"
        },
    },

];
export default iconArr;